import { render, staticRenderFns } from "./competitionPartnerPrePkSetList.vue?vue&type=template&id=248330f8&scoped=true"
import script from "./competitionPartnerPrePkSetList.vue?vue&type=script&lang=ts"
export * from "./competitionPartnerPrePkSetList.vue?vue&type=script&lang=ts"
import style0 from "./competitionPartnerPrePkSetList.vue?vue&type=style&index=0&id=248330f8&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248330f8",
  null
  
)

export default component.exports